import React, { Component } from 'react'
import Carousel from '@components/carousel'
import _get from 'lodash/get'
import { contentTypeList } from './const'

import {
  CarouselWrapper
} from './style'

class CarouselContainer extends Component {

  state = {
    carouselHeight: 0,
    isResized: false
  }

  componentDidMount() {
    if (window) {
      window.addEventListener('resize', this.updateCarouselHeight)
    }
  }

  updateCarouselHeight = () => {
    this.setState({
      isResized: true
    })
  }

  handleCarouselHeight = (height) => {
    this.setState({
      carouselHeight: height
    })
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.updateCarouselHeight)
    }
  }

  render() {
    const { carouselHeight, isResized } = this.state
    const { contentTypeName, video, isMobile, initialHeight, carouselClassName = '', slideToShow, withoutControls = null, noPaddingMobile } = this.props

    const stscroll = contentTypeList[contentTypeName] ? contentTypeList[contentTypeName].slideToScroll : 4,
      stshow = contentTypeList[contentTypeName] ? contentTypeList[contentTypeName].slideToShow : 4
    const numSlideToShow = slideToShow ? slideToShow : (isMobile ? stscroll : stshow),
      carouselWrapperHeight = carouselHeight ? '0px' : initialHeight
    return (
      <>
        <CarouselWrapper
          className={'carouselWrapper'}
          minHeight={carouselWrapperHeight}
          isResized={isResized}
          noPaddingMobile={noPaddingMobile}
        >
          <Carousel
            wrap={false}
            autoplay={false}
            sliderCoin={true}
            dragging={true}
            withoutControls={withoutControls !== null ? withoutControls : video.length < contentTypeList[contentTypeName].slideToShow}
            slidesToShow={numSlideToShow}
            slidesToScroll={Math.trunc(numSlideToShow)}
            transitionMode={'scroll'}
            cellSpacing={isMobile ? 8 : 16}
            framePadding={!isMobile ? '0px' : '0px 8px'}
            carouselHeightCallback={this.handleCarouselHeight}
            className={carouselClassName}
          >
            {this.props.children}
          </Carousel>
        </CarouselWrapper>

      </>
    )
  }
}

export default CarouselContainer


